import { LookupSelect } from 'components/Lookups/LookupSelect';
import React from 'react';
import { LookupModel } from 'types/graphql';
import { JeTypeLookupWrapper } from './JeTypeLookupWrapper';

interface IProps {
  includeDeleted?: boolean;
  selectedId?: number | null;
  onSelect: (item?: LookupModel) => void;
}

export const JeTypeSelect = (props: IProps): JSX.Element => {
  return (
    <JeTypeLookupWrapper includeDeleted={props.includeDeleted}>
      {({ queryDocument, queryVariables, extractLookups }) => (
        <LookupSelect
          extractLookupItems={extractLookups}
          queryDocument={queryDocument}
          queryVariables={queryVariables}
          selectedId={props.selectedId}
          onSelect={props.onSelect}
        />
      )}
    </JeTypeLookupWrapper>
  );
};
